<template>
  <ib-card
    class="ib-card-empty-chart d-flex flex-column"
    :animation="false"
  >
    <span class="card-title font-outfit-light">
      {{ title }}
    </span>
    <v-img
      contain
      :src="placeholderImage"
      class="placeholder-image"
      alt="placeholder-image"
      :aspect-ratio="16/9"
    />
  </ib-card>
</template>

<script>
export default {
  name: 'IbCardEmptyChart',

  props: {
    title: {
      type: String,
      required: true
    },
    placeholderImage: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.ib-card-empty-chart {
  padding: 15px 20px 10px;

  @include media-breakpoint-up($xl) {
    padding: 25px 30px 20px;
  }

  .card-title {
    color: $color-font;
    font-size: 24px;
  }
}
</style>
